import { Validate } from '@edgvr-front/util/validate';

Validate.ajv.addFormat('moduleName', {
  type: 'string',
  validate: (_: string) => {
    // Supports:
    // 'filename'
    // 'folder1/folder2/filename'

    return _.split('/').every((_: string) => _.length);
  },
});

export const moduleName = {
  type: 'string',
  pattern: '^\\S[a-zA-Z0-9./ ]+\\S$',
  minLength: 1,
  maxLength: 255,
  format: 'moduleName',
};
